export default {"src":"/_next/static/media/banner-img.e862b9ce.gif","height":720,"width":1334,"blurWidth":0,"blurHeight":0};